export default [
  {
    path: '/activity-20251020-main',
    component: () => import('./Page.vue'),
    meta: { title: '秋日集市', id: 3 },
  },
  {
    path: '/activity-20251020-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '秋日集市-报名页面', id: 3 },
  },
  {
    path: '/activity-20251020-rule-2',
    component: () => import('./Rule2.vue'),
    meta: { title: '秋日集市-规则说明', id: 3 },
  },
]
